const version = process.env.REACT_APP_TAG_VERSION || 'no-version-set';

function useVersion() {
  return version;
}

export default useVersion;
